










import { Component, Vue, Watch } from 'vue-property-decorator';
import Print from '@arcgis/core/widgets/Print';

@Component
export default class EsriPrint extends Vue {
    get printShow(): boolean {
        return this.$store.state.rightDrawerContent.print;
    }

    public printWidget: __esri.Print | null  = null;

    @Watch('printShow', { immediate: false, deep: true })
    public printShowChanged(value: boolean, oldValue: boolean) {
        if (value !== oldValue) {
            this.initPrintWidget();
        }
    }

    public onClose() {
        this.$store.dispatch('drawerToggleRight', 'nothing');
    }

    public initPrintWidget() {
        if (!this.printWidget) {
            this.printWidget = new Print({
                view: this.$store.state.mapView,
                container: 'printWidget',
                // AGOL print service, should this be something else??
                printServiceUrl: 'https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
            });
        }
    }

    public mounted() {
        console.log('EsriPrint: mounted()');
    }

}

